export const ModalDialogComponent_ChangePassword = {
    "max-width": "300px",
    title: "비밀번호 변경",
    closeText: "취소",
    saveText: "저장",
};
export const myPageInputs = [
    {
        type: "auto",
        key: "department",
        column_name: "department",
        label: "부서",
        list: [],
        value: "",
        col: "12",
        sm: "6",
        lg: "6",
        disabled: true,
    },
    {
        type: "auto",
        key: "position",
        column_name: "position",
        label: "직책",
        list: [],
        value: "",
        col: "12",
        sm: "6",
        lg: "6",
        disabled: true,
    },
    {
        icon: "mdi-phone-dial",
        key: "officePhoneNumber",
        column_name: "office_phone_number",
        label: "전화번호",
        value: "",
        col: "12",
        sm: "6",
        lg: "6",
        disabled: true,
        rules: [
            (v) => !!v || "전화번호 입력",
            (v) => !!(v &&
                /^(0(2|3[1-3]|4[1-4]|5[1-5]|6[1-4]|70))-(\d{3,4})-(\d{4})$/.test(v)) || "번호 형식 확인(070 시작, 숫자만 입력,자동 하이픈)",
        ],
    },
    {
        icon: "mdi-phone-in-talk",
        key: "internalNumber",
        column_name: "internal_number",
        label: "내선",
        value: "",
        col: "12",
        sm: "6",
        lg: "6",
        disabled: true,
        rules: [
            (v) => !!v || "내선번호 입력",
            (v) => !!(v && /[0-9]$/.test(v)) || "숫자만 입력",
        ],
    },
    {
        icon: "mdi-email-fast",
        key: "email",
        column_name: "email_address",
        label: "이메일",
        value: "",
        col: "12",
        sm: "6",
        lg: "6",
        disabled: true,
        rules: [
            (v) => !!v || "이메일 입력",
            (v) => !!(v && /^[A-Za-z0-9_\\.\\-]+@pionelectric.com+/.test(v)) ||
                "이메일 형식 확인(@pionelectric.com)",
        ],
    },
    {
        icon: "mdi-cellphone-text",
        key: "phoneNumber",
        column_name: "phone_number",
        label: "모바일",
        value: "",
        col: "12",
        sm: "6",
        lg: "6",
        disabled: true,
        rules: [
            (v) => !!v || "휴대전화번호 입력",
            (v) => !!(v && /^(?:(010-\d{4})|(01[1|6|7|8|9]-\d{3,4}))-(\d{4})$/.test(v)) ||
                "번호 형식 확인(ex : 010-1234-5678)",
        ],
    },
];
